import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API, useAuth } from "../AuthContext";
import { useI18n } from "../i18n";
import { Header } from "../components/Frumy";
import { CheckCircle, Spinner, Crown, ArrowRight, WarningCircle } from "@phosphor-icons/react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const [state, setState] = useState("checking"); // checking | success | error
  const sessionId = params.get("session_id");

  const poll = useCallback(async (attempt = 0) => {
    if (attempt >= 6) { setState("error"); return; }
    try {
      const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
      if (data.payment_status === "paid") {
        await refresh();
        setState("success");
        return;
      }
      if (data.status === "expired") { setState("error"); return; }
      setTimeout(() => poll(attempt + 1), 2000);
    } catch { setTimeout(() => poll(attempt + 1), 2000); }
  }, [sessionId, refresh]);

  useEffect(() => {
    if (!sessionId) { nav("/pro"); return; }
    poll(0);
  }, [sessionId, poll, nav]);

  return (
    <div className="min-h-screen"><Header />
      <div className="max-w-md mx-auto px-4 py-24 text-center" data-testid="payment-status">
        {state === "checking" && (
          <>
            <Spinner size={44} className="mx-auto animate-spin text-[var(--frumy-green)]" aria-hidden />
            <p className="font-bold text-lg mt-5">{t("paymentProcessing")}</p>
          </>
        )}
        {state === "success" && (
          <>
            <span className="inline-grid place-items-center h-16 w-16 rounded-full bg-emerald-100 text-[var(--frumy-green)] mb-5">
              <CheckCircle weight="fill" size={36} aria-hidden />
            </span>
            <h1 className="font-display text-3xl font-extrabold">{t("paymentSuccess")}</h1>
            <p className="flex items-center justify-center gap-1.5 text-[var(--frumy-lock)] font-bold mt-3">
              <Crown weight="fill" size={18} aria-hidden />{t("proUnlocked")}
            </p>
            <button data-testid="success-dashboard-btn" onClick={() => nav("/dashboard")}
              className="pill-btn cta-metal mt-8 inline-flex items-center gap-2 text-white font-bold px-6 py-3">
              {t("goToDashboard")}<ArrowRight weight="bold" size={18} aria-hidden />
            </button>
          </>
        )}
        {state === "error" && (
          <>
            <WarningCircle size={44} weight="fill" className="mx-auto text-amber-500" aria-hidden />
            <p className="font-bold text-lg mt-5">Verifica non riuscita. Riprova.</p>
            <button onClick={() => nav("/pro")} className="pill-btn mt-6 border border-[var(--frumy-border)] font-bold px-6 py-3">{t("goPro")}</button>
          </>
        )}
      </div>
    </div>
  );
}
